<header class="w-100 px-md-5 px-3">
	<nav class="header d-flex align-items-center justify-content-between">
		<a [href]="'sbb_header_logo_link' | translate" [ariaLabel]="'sbb_header_logo_link_accessibility' | translate">
			<img src="assets/img/eq-logos/Yellow.svg" class="header__logo"
				[alt]="'sbb_header_logo_accessibility' | translate" />
		</a>

		<!-- Hamburger Menu Button -->
		<button type="button" *ngIf="isMobileDevice" class="hamburger-menu" (click)="openHamburgerMenu()">
			<i class="icon-menu burger-icon-btn" aria-hidden="true"></i>
		</button>

		<!-- Menu Links -->
		<div class="d-none d-md-flex">
			<a class="fw-bold p-2 text-decoration-none" target="_blank" [href]="'sbb_header_needHelp_link' | translate">
				<i class="icon-question h5 position-relative" style="top: 2px" aria-hidden="true"></i>
				<span class="ms-1">{{ 'sbb_header_needHelp_button' | translate }}</span>
			</a>
			<span class="text-black-50 mx-2 align-content-center">|</span>
			<a class="text-decoration-none fw-bold p-2 ps-1" target="_blank"
				[href]="'sbb_footer_contactUs_link' | translate">
				<i class="icon-chat me-1" aria-hidden="true"></i>
				<span class="ms-1">{{ 'sbb_header_chat_button' | translate }}</span>
			</a>
		</div>
	</nav>
</header>
<eq-modal #hamburgerModal [ariaDescribedBy]="'hamburger-modal'"  [hideCloseBtn]="false"
		[isHamburgerMenu]="true">
	<!-- Mobile Menu -->
	<div class="mobile-menu d-flex flex-column">
		<a [href]="'sbb_header_logo_link' | translate" [ariaLabel]="'sbb_header_logo_link_accessibility' | translate">
			<img src="assets/img/eq-logos/Yellow.svg" class="header__logo mb-4"
				[alt]="'sbb_header_logo_accessibility' | translate" />
		</a>
		<a class="fw-bold p-2 text-decoration-none" target="_blank" [href]="'sbb_header_needHelp_link' | translate">
			<i class="icon-question h5 position-relative" style="top: 2px" aria-hidden="true"></i>
			<span class="ms-1">{{ 'sbb_header_needHelp_button' | translate }}</span>
		</a>
		<span class="bar-link ms-2 me-1 my-2"></span>
		<a class="text-decoration-none fw-bold p-2" target="_blank"
			[href]="'sbb_footer_contactUs_link' | translate">
			<i class="icon-chat me-1" aria-hidden="true"></i>
			<span class="ms-1">{{ 'sbb_header_chat_button' | translate }}</span>
		</a>
	</div>
</eq-modal>